const rules = Object.freeze({
  ruleBlur: {
    required: true,
    message: "此项必填",
    trigger: "blur",
  },
  ruleBlurArray: {
    required: true,
    message: "此项必填",
    trigger: "blur",
    type: "array",
  },
  ruleChange: {
    required: true,
    message: "此项必选",
    trigger: "change",
  },
  ruleChangeArray: {
    required: true,
    message: "此项必选",
    trigger: "change",
    type: "array",
  },
  ruleArray: {
    type: "array",
  },
});
export default rules;



// WEBPACK FOOTER //
// ./src/const/rules.js